<div *ngIf="businessAvailable" class="container mt-4" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong> তফসিল ৪</strong> <br>
            (ব্যবসা হইতে আয় থাকিলে নিম্নোক্ত তফসিলটি পূরণ করিতে হইবে)
        </div>
    </div>
    
    <div class="row my-4 px-2">
        <div class="col-sm-5">
            করদাতার নাম: {{returnData?.profileData?.assesName}}
        </div>
        <div class="col-sm-7 text-right">
            টি আইএন: 
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
        
    <div class="row mt-5 px-2">
        <div class="col-6">
            <div class="row">
                <div class="col-3">ব্যবসায়ের নাম:</div>
                <div class="col-9">
                    {{returnData?.headSummery?.businessSummeryData?.businessName.join(', ')}}
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-3">ব্যবসায়ের ধরণ:</div>
                <div class="col-9">
                    {{returnData?.headSummery?.businessSummeryData?.businessCategory.join(', ')}}
                </div>
            </div>             
        </div>
    </div>
    <div class="row px-2 mt-3">
        <div class="col-1">
            ঠিকানা:
        </div>
        <div class="col-11">
            {{returnData?.headSummery?.businessSummeryData?.businessAddress?.join(', ')}}
        </div>
    </div>
    
    <div class="row mt-4">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr class="text-center">
                        <td width="5%"><strong> ক্রমিক <br> নং </strong></td>
                        <td width="65%"><strong> আয়ের সার-সংক্ষেপ </strong></td>
                        <td width="30%"><strong> টাকার পরিমাণ </strong></td>
                    </tr>
                    <tr>
                        <td width="10%">১।</td>
                        <td width="60%">বিক্রয়/ টার্নওভার/ প্রাপ্তি </td>
                        <td width="30%">{{data?.salesTurnReceipts | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">২।</td>
                        <td width="60%">গ্রস মুনাফা</td>
                        <td width="30%">{{data?.grossProfit | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৩।</td>
                        <td width="60%">সাধারণ, প্রশাসনিক, বিক্রয়জনিত এবং অন্যান্য ব্যায়সমূহ</td>
                        <td width="30%">{{data?.gasoExpenses | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৪।</td>
                        <td width="60%">কুঋণ ব্যায়</td>
                        <td width="30%"></td>
                    </tr>
                    <tr>
                        <td width="10%">৫।</td>
                        <td width="60%">নিট মুনাফা (ক্রমিক ২ হইতে ক্রমিক ৩ ও ৪ এর বিয়োগফল)</td>
                        <td width="30%">{{result1 | formatNumberReturnView}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- second table  -->

    <div class="row mt-4">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr class="text-center">
                        <td width="10%"><strong> ক্রমিক <br> নং </strong></td>
                        <td width="60%"><strong> স্থিতিপত্রের সার-সংক্ষেপ </strong></td>
                        <td width="30%"><strong> টাকার পরিমাণ </strong></td>
                    </tr>
                    <tr>
                        <td width="10%">৬।</td>
                        <td width="60%">নগদ ও ব্যাংক স্থিতি </td>
                        <td width="30%">{{data?.cashHandBank | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৭।</td>
                        <td width="60%">মজুদ </td>
                        <td width="30%">{{data?.inventories | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৮।</td>
                        <td width="60%">স্থায়ী পরিসম্পদ </td>
                        <td width="30%">{{data?.fixedAssets | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৯।</td>
                        <td width="60%">অন্যান্য পরিসম্পদ </td>
                        <td width="30%">{{data?.otherAssets | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১০।</td>
                        <td width="60%">মোট পরিসম্পদ (০৬+০৭+০৮+০৯)</td>
                        <td width="30%">{{totalAssets | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১১।</td>
                        <td width="60%">প্রারম্ভিক মূলধন </td>
                        <td width="30%">{{data?.openingCp | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১২।</td>
                        <td width="60%">নীট মুনাফা </td>
                        <td width="30%">{{data?.netProfit | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১৩।</td>
                        <td width="60%">আয় বর্ষে ব্যবসা হইতে উত্তোলন </td>
                        <td width="30%">{{data?.withdrawalsIncmYr | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১৪।</td>
                        <td width="60%">সমাপনী মূলধন(১১+১২-১৩) </td>
                        <td width="30%">{{closingCapital | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১৫।</td>
                        <td width="60%">দায়সমূহ </td>
                        <td width="30%">{{data?.liabilities | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১৬।</td>
                        <td width="60%">মোট পরিসম্পদ ও দায়(১৪+১৫) </td>
                        <td width="30%">{{totalAssetsAndLiabilities | formatNumberReturnView}}</td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>